export default __webpack_public_path__ + "static/media/successfulMsg.cdac7a49.png";